import {doRequest} from '../../../helpers/network';
import {REQUEST_TYPE} from '../../../constants';
import {Revenue} from '../../../helpers/Urls';

const INITIAL_STATE = {
  hasError: false,
  error: '',
  submittingInvoicingData: false,
  invoicingTableData: [],
  revenueHeadsColumnData: [],
  generatingDeltaInvoice: false,
  requestingAction: false,
};

export const GET_DELTA_INVOICING_DATA = 'GET_DELTA_INVOICING_DATA';
export const GET_DELTA_INVOICING_DATA_COMPLETED =
  'GET_DELTA_INVOICING_DATA_COMPLETED';
export const GET_DELTA_INVOICING_DATA_FAILED =
  'GET_DELTA_INVOICING_DATA_FAILED';

export const GENERATE_DELTA_INVOICE = 'GENERATE_DELTA_INVOICE';
export const GENERATE_DELTA_INVOICE_COMPLETED =
  'GENERATE_DELTA_INVOICE_COMPLETED';
export const GENERATE_DELTA_INVOICE_FAILED = 'GENERATE_DELTA_INVOICE_FAILED';

export const REJECT_VERIFY_INVOICE = 'REJECT_VERIFY_INVOICE';
export const REJECT_VERIFY_INVOICE_COMPLETED =
  'REJECT_VERIFY_INVOICE_COMPLETED';
export const REJECT_VERIFY_INVOICE_FAILED = 'REJECT_VERIFY_INVOICE_FAILED';

export const GET_ORDER_INVOICE_QC = 'GET_ORDER_INVOICE_QC';
export const GET_ORDER_INVOICE_QC_COMPLETED = 'GET_ORDER_INVOICE_QC_COMPLETED';
export const GET_ORDER_INVOICE_QC_FAILED = 'GET_ORDER_INVOICE_QC_FAILED';

export const getDeltaInvoicingData = (requestData) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: GET_DELTA_INVOICING_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Revenue.getDeltaInvoicingDataURL(),
        data: requestData,
      });

      const {data, status} = response || {};
      if (status === true) {
        dispatch({type: GET_DELTA_INVOICING_DATA_COMPLETED, payload: data});
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: GET_DELTA_INVOICING_DATA_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: GET_DELTA_INVOICING_DATA_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const generateDeltaInvoice = (requestData) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: GENERATE_DELTA_INVOICE});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Revenue.generateDeltaInvoiceURL(),
        data: requestData,
      });

      const {data, status} = response || {};
      if (status === true) {
        dispatch({type: GENERATE_DELTA_INVOICE_COMPLETED, payload: data});
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: GENERATE_DELTA_INVOICE_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: GENERATE_DELTA_INVOICE_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const rejectVerifyInvoice = (requestData) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: REJECT_VERIFY_INVOICE});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Revenue.rejectVerifyInvoiceURL(),
        data: requestData,
      });

      const {data, status} = response || {};
      if (status === true) {
        dispatch({type: REJECT_VERIFY_INVOICE_COMPLETED, payload: data});
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: REJECT_VERIFY_INVOICE_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: REJECT_VERIFY_INVOICE_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

//invoice qc
export const getOrderInvoiceQC = ({
  order_id,
  invoice_config_id,
  customer_id,
  customer_config_id,
  invoice_status,
}) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: GET_ORDER_INVOICE_QC});

      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Revenue.getOrderInvoiceQCURL({
          order_id,
          invoice_config_id,
          customer_id,
          customer_config_id,
          invoice_status,
        }),
      });

      const {data, status} = response || {};
      if (status) {
        dispatch({type: GET_ORDER_INVOICE_QC_COMPLETED, payload: data});
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: GET_ORDER_INVOICE_QC_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: GET_ORDER_INVOICE_QC_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export default (state = INITIAL_STATE, action) => {
  const {type, payload} = action || {};
  switch (type) {
    case GET_DELTA_INVOICING_DATA:
      return {
        ...state,
        submittingInvoicingData: true,
        hasError: false,
        error: '',
      };
    case GET_DELTA_INVOICING_DATA_COMPLETED:
      return {
        ...state,
        submittingInvoicingData: false,
        invoicingTableData: payload?.records,
        maxOrders: payload?.max_no_of_orders,
        revenueHeadsColumnData: payload?.revenue_heads,
      };
    case GET_DELTA_INVOICING_DATA_FAILED:
      return {
        ...state,
        submittingInvoicingData: false,
        hasError: true,
        error: payload?.error,
      };
    case GENERATE_DELTA_INVOICE:
      return {
        ...state,
        generatingDeltaInvoice: true,
        hasError: false,
        error: '',
      };
    case GENERATE_DELTA_INVOICE_COMPLETED:
      const idsToRemove = payload?.records?.map((r) => r.id) || [];
      return {
        ...state,
        generatingDeltaInvoice: false,
        invoicingTableData: state.invoicingTableData.filter(
          (item) => !idsToRemove.includes(item.id),
        ),
      };
    case GENERATE_DELTA_INVOICE_FAILED:
      return {
        ...state,
        generatingDeltaInvoice: false,
        hasError: true,
        error: payload?.error,
      };
    case REJECT_VERIFY_INVOICE:
      return {
        ...state,
        requestingAction: true,
        hasError: false,
        error: '',
      };
    case REJECT_VERIFY_INVOICE_COMPLETED:
      return {
        ...state,
        requestingAction: false,
        invoicingTableData: state.invoicingTableData.filter(
          (item) => item.id !== payload?.record_id,
        ),
      };
    case REJECT_VERIFY_INVOICE_FAILED:
      return {
        ...state,
        requestingAction: false,
        hasError: true,
        error: payload?.error,
      };
    default:
      return state;
  }
};
